export const groupReportArabic:Record<string,string> = {
  'Branch summary':'ملخص الفرع',
  'Group Reports':'تقارير الجروبات',
  'Course Bookings Report':'تقرير حجوزات الكورسات',
  'Lecture':'المحاضرة',
  'Group finances, attendance and lecture progress':'مالية الجروب والحضور ومتابعة المحاضرات',
  'Group financial report':'التقرير المالي للجروب',
  'Group attendance report':'تقرير حضور وغياب الجروب',
  'Attendance dashboard':'داشبورد الحضور والغياب',
  'Group report sections':'أقسام تقارير الجروب',
  'Select a group':'اختار الجروب',
  'Search group code or name...':'ابحث بكود الجروب أو اسمه...',
  'No matching groups':'مفيش جروبات مطابقة للبحث',
  'Loading group reports':'جارٍ تحميل تقارير الجروب',
  'Could not load group reports':'تعذر تحميل تقارير الجروب. حاول مرة تانية.',
  'Group report access denied':'مش مسموح لحسابك بعرض التقرير في النطاق ده.',
  'Choose a group to view financial and attendance reports':'اختار الجروب لعرض تقرير المالية والحضور والغياب',
  'No groups in this report scope':'مفيش جروبات في نطاق التقرير',
  'Final Reception agreement for this registration; services are excluded.':'اتفاق الريسبشن النهائي لنفس التسجيل؛ الخدمات الإضافية غير محسوبة.',
  'Fully paid':'مسدد بالكامل',
  'Outstanding balance':'عليه باقي',
  'Needs review':'يحتاج مراجعة',
  'Group totals':'إجماليات الجروب',
  'Known totals only':'إجمالي المبالغ المتحقق منها فقط',
  'Agreed total':'إجمالي الاتفاق',
  'Collected':'المحصّل',
  'Unverified balances are excluded from totals and are never treated as fully paid.':'الأرصدة غير المتحقق منها مستبعدة من الإجماليات ومش بتتحسب مسددة بالكامل.',
  'Financial details by student':'التفاصيل المالية لكل طالب',
  'Profile training type':'حالة الطالب من البروفايل',
  'Credits / waivers':'رصيد تحويل / إعفاءات',
  'Payment status':'الحالة المالية',
  'Payment schedule':'مواعيد الدفعات المتبقية',
  'Source evidence needs review':'مستندات المصدر تحتاج مراجعة',
  'No outstanding payments':'مفيش دفعات متبقية',
  'No payment dates recorded':'مفيش مواعيد دفع مسجلة',
  'Balance without payment dates':'باقي بدون مواعيد دفع',
  'Schedule exceeds balance':'الجدول أكبر من المبلغ المتبقي',
  'Not specified in profile':'غير محدد في البروفايل',
  'Offline':'أوفلاين',
  'Not scheduled':'غير مجدول',
  'Each bar represents one recorded lecture. Future and cancelled lectures are excluded from percentages.':'كل شريط يمثل محاضرة مسجلة. المحاضرات القادمة والملغية مستبعدة من النسب.',
  'Held lectures':'محاضرات انعقدت',
  'Planned lectures':'المحاضرات المخططة',
  'Attendance rate':'نسبة الحضور',
  'Absence rate':'نسبة الغياب',
  'Attendance by lecture':'الحضور والغياب لكل محاضرة',
  'No lectures recorded for this group':'مفيش محاضرات مسجلة للجروب',
  'The timetable does not yet contain all planned lectures.':'جدول المحاضرات لسه مش شامل كل المحاضرات المخططة.',
  'Student mode comes from the profile':'حالة الطالب من البروفايل',
  'Late counts as present; excused counts as absent. Missing marks stay separate. Percentages use the lecture roster.':'المتأخر محسوب ضمن الحضور، والمعتذر ضمن الغياب. غير المسجل منفصل. النسب من عدد طلاب المحاضرة.',
  'Lecture attendance summary':'ملخص أعداد الحضور والغياب لكل محاضرة',
  'Session status':'حالة المحاضرة',
  'Actual roster':'العدد الفعلي',
  'Online present / absent':'أونلاين: حضر / غاب',
  'Offline present / absent':'أوفلاين: حضر / غاب',
  'Unspecified present / absent':'غير محدد: حضر / غاب',
  'Roster reconstructed from available records':'العدد مستنتج من السجلات المتاحة',
  'Lecture not available in this group':'المحاضرة غير متاحة في الجروب ده',
  'Lecture student details':'تفاصيل حضور الطلاب في المحاضرة',
  'Attendance status':'حالة الحضور',
  'Attendance recorded':'الحضور مسجل',
  'Not applicable':'لا ينطبق',
  'Not recorded':'غير مسجل',
  'Profile training type is current, not a historical record of how the student connected. Unknown or Hybrid profile values stay unspecified.':'حالة التدريب من البروفايل الحالي، وليست تسجيلًا تاريخيًا لطريقة الدخول. الحالة غير المحددة أو Hybrid تفضل غير محددة.',
  'Saved lecture rosters are used when available. Otherwise recorded students and memberships joined before the lecture are shown; deleted membership history may be unavailable.':'بنستخدم قائمة طلاب المحاضرة المحفوظة لو موجودة. غير كده بنعرض الطلاب المسجل حضورهم والمنضمين قبل المحاضرة؛ تاريخ العضويات المحذوفة ممكن يكون غير متاح.',
};
